import config from "../config";
import { getJwtToken } from "./tokens";
import { mountedRootComponent } from "../App";

import axios from "axios";

export default async function authenticatedFetch(route) {
    // route must start without slash
    
    const res = await fetch(`${config.back.url}/${route}`, { headers: {'Authorization': `Bearer ${getJwtToken()}`} });

    // If status 401 is returned, unauthenticate the user
    if (res.status === 401) mountedRootComponent.showLogin();

    if (!res.ok) throw Error(res.statusText);

    const contentType = res.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
        return res.json();
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/services/authenticatedFetch.js